import {path} from 'ramda'
import {connect} from '@modifi/redux'
import {selectSearchObj, aReplace} from '@modifi/router'

import SearchFilterForm from './SearchFilterForm'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: Record<string, any>) => ({
  location: path(['router', 'location'], state),
  search: selectSearchObj(state),
})

const mapDispatchToProps = {
  replaceUrl: aReplace,
}

// @ts-expect-error to be fixed
export default connect(mapStateToProps, mapDispatchToProps)(SearchFilterForm)
